import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AddressModalForm from './addressmodal-form'

import CepRepository from '@/shared/http/repositories/external/cep.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

const ModalAddressModel = {
  id: null,
  cep: null,
  endereco: null,
  bairro: null,
  uf: null,
  municipio: null,
  numero: null,
  complemento: null
}

export default {
  name: 'AddressModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: ModalAddressModel,
      form: AddressModalForm
    }
  },
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onLoad () {
      this.onClear()
    },
    showModal () {
      this.onClear()
      this.$refs['modal-address'].show()
    },
    hideModal () {
      this.onClear()
      this.$refs['modal-address'].hide()
    },
    onSearchCep () {
      if (this.form.cep.value) {
        loading.push()
        CepRepository.GetCEP(this.form.cep.value)
          .then((response) => {
            var data = response.data
            this.$refs.number.focus()

            this.$nextTick(() => {
              this.form.endereco.value = data.logradouro
              this.form.municipio.value = data.localidade
              this.form.uf.value = data.uf
              this.form.complemento.value = data.complemento
              this.form.bairro.value = data.bairro
              loading.close()
            })
          })
          .catch((err) => {
            loading.close()
            this.onException(err)
          })
      }
    },
    onCreate () {
      this.data.logradouro = this.data.endereco
      PersonRepository.CreateEndereco(this.card.pessoa.id, this.data)
        .then((response) => {
          if (response.status === 200) {
            let endereco = this.data.endereco + ', ' + this.data.numero + ', ' + this.data.bairro + ', ' + this.data.municipio + '/' + this.data.uf
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_endereco_adicionado', 'O endereço ' + endereco + ' foi cadastrado! ', this.ip, this.latitude, this.longitude, this.card.id)
            this.$emit('Reload')
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.pop()
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/addresses/modal/addressmodal.js